import { Component, OnInit } from '@angular/core';
import { TableColumnDef } from 'app/shared/tables/table-column-def';
import { PriceContractsList } from './price-contracts.model';
import {MatDialog} from '@angular/material/dialog';
import {CreatePriceContractDialogComponent} from 'app/components/create-price-contract-dialog/create-price-contract-dialog.component';
import {finalize} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment as env} from '../../../../../environments/environment';
import {HttpService, SettingsProvider} from 'app/core';
import {ProductsDataService} from '../../services/products.data.service';
import {DeletePriceContractDialogComponent} from 'app/components/delete-price-contract-dialog/delete-price-contract-dialog.component';
import {UpdatePriceContractDialogComponent} from 'app/components/update-price-contract-dialog/update-price-contract-dialog.component';


export interface PriceContract {
    id: number;
    contractType: string;
    validFrom: string;
    validTo: string;
    price: number;
}

@Component({
    selector: 'pr-price-contracts',
    templateUrl: './price-contracts.component.html',
    styleUrls: ['./price-contracts.component.scss'],
})

export class PriceContractsComponent implements OnInit {
    public tableData: [];
    public columnsData: TableColumnDef[];
    public tableId: string;
    public isLoading = true;
    columns: TableColumnDef[];

    constructor(
        private dialog: MatDialog,
        public settingsService: SettingsProvider,
        public dataService: ProductsDataService,
        private http: HttpService,
    ) {}

    public ngOnInit(): void {
        const tableInfo = PriceContractsList.tableInfo();
        this.columnsData = tableInfo.columns;
        this.tableId = tableInfo.tableId;

        this.loadPriceContracts();
    }

    openCreatePriceContractDialog(): void {
        const dialogRef = this.dialog.open(CreatePriceContractDialogComponent, {
            minWidth: '500px',
            minHeight: '100px',
        });

        dialogRef.afterClosed()
            .subscribe(
                (dialogClose: {confirm: boolean}) => {
                    if (dialogClose && dialogClose.confirm) { this.loadPriceContracts(); }
                }
            );
    }

    openDeletePriceContractDialog(contractId: number): void {
        const dialogRef = this.dialog.open(DeletePriceContractDialogComponent, {
            data: {
                contractId
            }
        });

        dialogRef.afterClosed()
            .subscribe(
                (dialogClose: {confirm: boolean}) => {
                    if (dialogClose && dialogClose.confirm) { this.loadPriceContracts(); }
                }
            );
    }

    openUpdatePriceContractDialog(contract: PriceContract): void {
        const dialogRef = this.dialog.open(UpdatePriceContractDialogComponent, {
            minWidth: '500px',
            minHeight: '100px',
            data: {
                contract
            }
        });

        dialogRef.afterClosed()
            .subscribe(
                (dialogClose: {confirm: boolean}) => {
                    if (dialogClose && dialogClose.confirm) { this.loadPriceContracts(); }
                }
            );
    }

    public addPriceContract(): void {
        this.openCreatePriceContractDialog();
    }

    public deletePriceContract(contractId: number): void {
        this.openDeletePriceContractDialog(contractId);
    }

    public updatePriceContract(contract: PriceContract): void {
        this.openUpdatePriceContractDialog(contract);
    }


    private getPriceContracts(): Observable<any> {
        const url = `${this.settingsService.configuration.url}${env.PriceContractDataService.apiUrlGetList}/${this.dataService.productId}/contracts`;
        return this.http.get(url);
    }

    private loadPriceContracts(): void {
        this.isLoading = true;
        this.getPriceContracts()
            .pipe(finalize(() => this.isLoading = false))
            .subscribe(
                contracts => {
                    this.tableData = contracts.items;
                },
                logErr => {
                    console.log(logErr);
                }
            );
    }
}
